<template>
  <div id="app">
    <div class="header">
      <h1>🎮 五子棋对战</h1>
      <p>体验经典五子棋乐趣</p>
    </div>
    <GomokuBoard />
    <div class="footer">
      <p>© 2024 五子棋对战 - 基于 Spring Boot + Vue</p>
    </div>
  </div>
</template>

<script>
import GomokuBoard from './components/GomokuBoard.vue'

export default {
  name: 'App',
  components: {
    GomokuBoard
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

#app {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.header h1 {
  margin: 0 0 10px 0;
  color: white;
  font-size: 2.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.header p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
}

.footer {
  margin-top: auto;
  padding: 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header h1 {
    font-size: 2rem;
  }

  .header p {
    font-size: 1rem;
  }
}
</style>
